<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/contracts">Contracts</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contract.seller_type == 'Agent' && contract.seller_name">
                        <router-link :to="`/agents/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item" v-else-if="contract.seller_type == 'Agency' && contract.seller_name">
                        <router-link :to="`/agencies/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <template v-if="!contract.id">
                        <vue-headful :title="'[Create Contract] - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create Contract</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Contract] - AMOS365'" />
                        <li class="breadcrumb-item">
                            <router-link :to="`/products/view/${contract.product_id}`">{{ contract.product_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="`/contracts/view/${contract.id}`">
                                <span v-if="contract.writing_nbr">{{ contract.writing_nbr }}</span>
                                <span v-else>View Contract</span>
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit Product Contract</span>
                <span v-else>New Product Contract</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_id, 'text-muted-no': !errors.product_id}">
                                    Product: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contract.product_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <template v-if="!contract.id">
                                        <v-select
                                            v-model="contract.product_id"
                                            :options="products"
                                            :reduce="product => product.id"
                                            label="product_name"
                                            :class="{'is-invalid': errors.product_id}"
                                            placeholder="-- Select a Product --" />

                                        <div class="text-danger mt-2" v-if="errors.product_id">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.product_id">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <router-link :to="`/products/view/${contract.product_id}`" title="View Product">{{ contract.product_name }}</router-link>
                                    </template>
                                </div>
                            </div>
                            <template v-if="!contract.id">
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.seller_type, 'text-muted-no': !errors.seller_type}">
                                        Seller Type: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contract.seller_type"></i>
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        <b-form-radio-group v-model="contract.seller_type" name="seller_type" plain>
                                            <b-form-radio value="Agency">Agency</b-form-radio>
                                            <b-form-radio value="Agent">Agent</b-form-radio>
                                        </b-form-radio-group>

                                        <div class="text-danger mt-2" v-if="errors.seller_type">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.seller_type">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': (errors.seller_id_agency || errors.seller_id_agent)}">
                                        Seller:  <i class="fa fa-sm fa-asterisk text-danger" v-if="!seller_id_agent && !seller_id_agency"></i>
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        <span v-if="!contract.seller_type">-- Select Seller Type --</span>

                                        <v-select
                                            v-if="contract.seller_type === 'Agency'"
                                            v-model="seller_id_agency"
                                            :options="agencies"
                                            :reduce="agency => agency.id"
                                            label="agency_name"
                                            :class="{'is-invalid': errors.seller_id_agency}"
                                            placeholder="-- Select an Agency --" />

                                        <v-select
                                            v-if="contract.seller_type === 'Agent'"
                                            v-model="seller_id_agent"
                                            :options="seller_agents"
                                            :reduce="agent => agent.id"
                                            label="agent_name"
                                            :class="{'is-invalid': errors.seller_id_agent}"
                                            placeholder="-- Select an Agent --"
                                            @search="searchSellerAgents"
                                            :filterable="false" />

                                        <div class="text-danger mt-2" v-if="errors.seller_id_agency">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.seller_id_agency">{{ err }}</li>
                                            </ul>
                                        </div>
                                        <div class="text-danger mt-2" v-if="errors.seller_id_agent">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.seller_id_agent">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right">
                                        Seller:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">                                        
                                        <template v-if="contract.seller_type == 'Agent'">
                                            <router-link :to="`/agents/view/${contract.seller_id}`">{{ contract.seller_name }}</router-link>
                                        </template>
                                        <template  v-else-if="contract.seller_type == 'Agency'">
                                            <router-link :to="`/agencies/view/${contract.seller_id}`">{{ contract.seller_name }}</router-link>
                                        </template>
                                    </div>
                                </div>
                            </template>

                            <template v-if="contract.id">
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right">
                                        Edit Mgr Level:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        <b-form-checkbox v-model="edit_manager_level" :value="true" :unchecked-value="false" plain />
                                    </div>
                                </div>
                            </template>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_level_id, 'text-muted-no': !errors.product_level_id}">
                                    Product Level:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <template v-if="!contract.id || edit_manager_level">
                                        <v-select
                                            v-if="contract.product_id"
                                            v-model="contract.product_level_id"
                                            :options="levels"
                                            :reduce="level => level.id"
                                            label="product_level_name"
                                            :class="{'is-invalid': errors.product_level_id}"
                                            placeholder="-- Select Product Level --" />

                                        <span v-else>-- Select a Product to View Level Options --</span>

                                        <div class="text-danger mt-2" v-if="errors.product_level_id">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.product_level_id">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ contract.product_level_name }} <span v-if="contract.product_level_commission">, Commission: {{ contract.product_level_commission }}</span>
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.date_of_change, 'text-muted-no': !errors.date_of_change}">
                                    Date of Change:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <template v-if="!contract.id || edit_manager_level">
                                        <input type="date" name="date_of_change" v-model="contract.date_of_change" placeholder="Select Date of Change" class="form-control" :class="{'is-invalid': errors.date_of_change}" />

                                        <div class="text-danger mt-2" v-if="errors.date_of_change">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.date_of_change">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <span v-if="contract.date_of_change">{{ contract.date_of_change | moment("MM/DD/YYYY") }}</span>
                                    </template>
                                </div>
                            </div>
                            <template v-if="!contract.id || edit_manager_level">
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.manager_type, 'text-muted-no': !errors.manager_type}">
                                        Manager Type:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        <b-form-radio-group v-model="contract.manager_type" name="manager_type" plain>
                                            <b-form-radio value="Agency">Agency</b-form-radio>
                                            <b-form-radio value="Agent">Agent</b-form-radio>
                                            <b-form-radio :value="null">N/A</b-form-radio>
                                        </b-form-radio-group>

                                        <div class="text-danger mt-2" v-if="errors.manager_type">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.manager_type">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': (errors.manager_id_agency || errors.manager_id_agent), 'text-muted-no': !(errors.manager_id_agency || errors.manager_id_agent)}">
                                        Manager:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">

                                        <v-select
                                            v-if="contract.manager_type === 'Agency'"
                                            v-model="manager_id_agency"
                                            :options="agencies"
                                            :reduce="agency => agency.id"
                                            label="agency_name"
                                            :class="{'is-invalid': errors.manager_id_agency}"
                                            placeholder="-- Select an Agency --" />

                                        <v-select
                                            v-if="contract.manager_type === 'Agent'"
                                            v-model="manager_id_agent"
                                            :options="manager_agents"
                                            :reduce="agent => agent.id"
                                            label="agent_name"
                                            :class="{'is-invalid': errors.manager_id_agent}"
                                            placeholder="-- Select an Agent --"
                                            @search="searchManagerAgents"
                                            :filterable="false" />

                                        <div class="text-danger mt-2" v-if="errors.manager_id_agency">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.manager_id_agency">{{ err }}</li>
                                            </ul>
                                        </div>
                                        <div class="text-danger mt-2" v-if="errors.manager_id_agent">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.manager_id_agent">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right">
                                        Manager:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        {{ contract.manager_name }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.contract_status_id, 'text-muted-no': !errors.contract_status_id}">
                                    Contract Status: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contract.contract_status_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="contract.contract_status_id" :options="statusOptions" :class="{'is-invalid': errors.contract_status_id}" />

                                    <a href="/help/contract-statuses" target="_blank">See Status Helper Reference Page for more Status definitions</a>

                                    <div class="text-danger mt-2" v-if="errors.contract_status_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.contract_status_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Contract Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="contract.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.writing_nbr, 'text-muted-no': !errors.writing_nbr}">Writing#:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-textarea v-model="contract.writing_nbr" :class="{'form-control': true, 'is-invalid': errors.writing_nbr}" placeholder="Enter Writing Number" maxlength="1000" />

                                    <div class="text-danger mt-2" v-if="errors.writing_nbr">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.writing_nbr">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_writing_nbr_sent, 'text-muted-no': !errors.is_writing_nbr_sent}">Writing# Sent:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="contract.is_writing_nbr_sent" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_writing_nbr_sent">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.is_writing_nbr_sent">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.commission, 'text-muted-no': !errors.commission}">Commission:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="contract.commission" :class="{'form-control': true, 'is-invalid': errors.commission}" placeholder="Enter Commission" :disabled="true" />

                                    <div class="mt-1 text-info">-- Commission is now determined from the assigned Product Level --</div>

                                    <div class="text-danger mt-2" v-if="errors.commission">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.commission">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.advance, 'text-muted-no': !errors.advance}">Advance:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="contract.advance" :class="{'form-control': true, 'is-invalid': errors.advance}" placeholder="Enter Advance" />

                                    <div class="text-danger mt-2" v-if="errors.advance">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.advance">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.requested_date, 'text-muted-no': !errors.requested_date}">
                                    Date Requested:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="contract.requested_date" :class="{'form-control': true, 'is-invalid': errors.requested_date}" placeholder="Enter Date Requested" />

                                    <div class="alert alert-warning mt-1" v-if="contract.created_at && !contract.requested_date">
                                        <div class="mb-1">Contract Created Date: <strong>{{ contract.created_at | moment('MM/DD/YYYY') }}</strong></div>
                                        <a href="javascript:void(0)" class="btn-link" v-on:click="setRequested()">
                                            Set Date Requested to Contract Created Date of {{ contract.created_at | moment('MM/DD/YYYY') }}
                                        </a>
                                    </div>

                                    <div class="text-danger mt-2" v-if="errors.requested_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.requested_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.certification_date, 'text-muted-no': !errors.certification_date}">Certification Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="contract.certification_date" :class="{'form-control': true, 'is-invalid': errors.certification_date}" placeholder="Enter Certification Date" />

                                    <div class="text-danger mt-2" v-if="errors.certification_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.certification_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.credentialing_date, 'text-muted-no': !errors.credentialing_date}">Credentialing Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="contract.credentialing_date" :class="{'form-control': true, 'is-invalid': errors.credentialing_date}" placeholder="Enter Credentialing Date" />

                                    <div class="text-danger mt-2" v-if="errors.credentialing_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.credentialing_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.sent_date, 'text-muted-no': !errors.sent_date}">Date Sent:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="contract.sent_date" :class="{'form-control': true, 'is-invalid': errors.sent_date}" placeholder="Enter Date Sent" />

                                    <div class="text-danger mt-2" v-if="errors.sent_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.sent_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.termination_date, 'text-muted-no': !errors.termination_date}">Termination Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="contract.termination_date" :class="{'form-control': true, 'is-invalid': errors.termination_date}" placeholder="Enter Termination Date" />

                                    <div class="text-danger mt-2" v-if="errors.termination_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.termination_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Seller Details</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-md-4 col-12 text-md-right text-muted">
                                    Master Level:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="seller_details.master_level">{{ seller_details.master_level }}</span>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4 col-12 text-md-right text-muted">
                                    Direct Manager:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/agents/view/${seller_details.direct_manager_id}`" v-if="seller_details.direct_manager && seller_details.direct_manager_type === 'Agent'">
                                        {{ seller_details.direct_manager.first_name }} {{ seller_details.direct_manager.last_name }}
                                    </router-link>
                                    <router-link :to="`/agencies/view/${seller_details.direct_manager_id}`" v-else-if="seller_details.direct_manager && seller_details.direct_manager_type === 'Agency'">
                                        {{ seller_details.direct_manager.agency_name }}
                                    </router-link>
                                    <span v-if="seller_details.direct_manager_type">({{ seller_details.direct_manager_type }})</span>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4 col-12 text-md-right text-muted">
                                    Affiliation Manager:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/agents/view/${seller_details.top_manager_id}`" v-if="seller_details.top_manager && seller_details.top_manager_type === 'Agent'">
                                        {{ seller_details.top_manager.first_name }} {{ seller_details.top_manager.last_name }}
                                    </router-link>
                                    <router-link :to="`/agencies/view/${seller_details.top_manager_id}`" v-else-if="seller_details.top_manager && seller_details.top_manager_type === 'Agency'">
                                        {{ seller_details.top_manager.agency_name }}
                                    </router-link>
                                    <span v-if="seller_details.top_manager_type">({{ seller_details.top_manager_type }})</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Seller's Assigned Products ({{ products_sold.length }})</strong>
                        </div>
                        <div class="card-body" style="max-height: 350px;overflow-y: auto;">
                            <table class="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Level</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="product in products_sold">
                                        <td>
                                            <router-link :to="`/contracts/view/${product.id}`">{{ product.product_name }}</router-link>
                                        </td>
                                        <td>{{ product.product_level_name }}</td>
                                        <td>
                                            <label :class="'badge badge-'+product.contract_status_color">{{ product.contract_status_type }} - {{ product.contract_status_name }}</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            <b-form-textarea v-model="contract.notes" :class="{'is-invalid': errors.notes}" placeholder="Enter Contract Notes" rows="3"></b-form-textarea>
                        </div>
                    </div>

                    <files-add ref="contractEditFiles" />
                </div>
            </div>

            <div class="">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveContract()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Creating...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveContract()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>

                <template v-if="!id">
                    <b-form-checkbox v-model="save_and_create_new" :value="true" :unchecked-value="false" plain class="d-inline-block ml-3">
                        Save and Assign Another <i class="fa fa-question-circle" title="If Checked, AMOS will save and assign the current contract and then reset this form for you to assign another product"></i>
                    </b-form-checkbox>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                save_and_create_new: false,
                edit_manager_level: false,
                id: this.$route.params.id,
                contract: {},
                seller_id_agency: null,
                seller_id_agent: null,
                manager_id_agency: null,
                manager_id_agent: null,
                seller_details: {},
                errors: {},
                products: [],
                agencies: [],
                seller_agents: [],
                manager_agents: [],
                files: [],
                statuses: [],
                products_sold: [],
            }
        },

        watch: {
            seller_id_agent(newVal, oldVal){
                //Check for Null
                if(!newVal)
                {
                    //Reset Some Values
                    this.seller_details = null;
                    this.products_sold = [];
                }

                //Fetch The Agent Details
                this.getSellerDetails('Agent', newVal);
            },

            seller_id_agency(newVal, oldVal){
                //Check for Null
                if(!newVal)
                {
                    //Reset Some Values
                    this.seller_details = null;
                    this.products_sold = [];
                }

                //Fetch The Agent Details
                this.getSellerDetails('Agency', newVal);
            },
        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },

            statusOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Contract Status --'}];

                //Main Loop
                for(var i = 0; i < this.statuses.length; i++)
                {
                    //Build the label
                    var label = this.statuses[i].contract_status_type + ' - ' + this.statuses[i].contract_status_name;

                    //Push
                    options.push({value: this.statuses[i].id, text: label});
                }

                //Send it
                return options;
            },

            levels(){
                //Check for empty product
                if(!this.contract.product_id)
                {
                    return [];
                }

                //Loop and Check
                for (var i = this.products.length - 1; i >= 0; i--)
                {
                    //Check it
                    if(this.products[i].id === this.contract.product_id)
                    {
                        return this.products[i].levels;
                    }
                }

                return [];
            },
        },

        methods: {

            getContract(){
                //Send it
                this.$http.get('/contracts/edit' + (this.id ? '/'+this.id : ''), this.$route.query)
                    .then(response => {
                        //Set the contract
                        this.contract = response.data.contract;
                        this.products = response.data.products;
                        this.agencies = response.data.agencies;
                        this.statuses = response.data.statuses;

                        //Check for Agent Sellers or Managers
                        if(this.contract.seller_type === 'Agent')
                        {
                            //Push
                            this.seller_agents.push({id: this.contract.seller_id, agent_name: this.contract.seller_name});

                            //Set the Helper ID
                            this.seller_id_agent = this.contract.seller_id;
                        }
                        else
                        {
                            //Set the Helper ID
                            this.seller_id_agency = this.contract.seller_id ?? null;
                        }

                        if(this.contract.manager_type === 'Agent')
                        {
                            //Push
                            this.manager_agents.push({id: this.contract.manager_id, agent_name: this.contract.manager_name});

                            //Set the Helper ID
                            this.manager_id_agent = this.contract.manager_id;
                        }
                        else
                        {
                            //Set the Helper ID
                            this.manager_id_agency = this.contract.manager_id ?? null;
                        }
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveContract(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Append Stuff to the Payload
                this.contract.seller_id_agent = this.seller_id_agent ?? null;
                this.contract.seller_id_agency = this.seller_id_agency ?? null;
                this.contract.manager_id_agent = this.manager_id_agent ?? null;
                this.contract.manager_id_agency = this.manager_id_agency ?? null;
                this.contract.edit_manager_level = this.edit_manager_level;

                //Get it
                var file_data = this.$refs.contractEditFiles.getFilesForSave();

                //Set
                this.contract.file_names = file_data.file_names;

                //Send it
                this.$http
                .postWithFiles('/contracts/save', this.contract, file_data.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Contract ' + (this.contract.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    if(this.save_and_create_new)
                    {
                        //Reset Some Values
                        this.contract.notes = null;
                        this.contract.product_id = null;
                        this.contract.product_level_id = null;

                        //Reset the Files
                        this.$refs.contractEditFiles.reset();

                        //Push the New Contract
                        this.products_sold.push(response.data);
                    }
                    else
                    {
                        //Push to the contract view
                        this.$router.push('/contracts/view/' + response.data.id);
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the errors to the file helper
                        this.$refs.contractEditFiles.setErrors(this.errors);

                        //Alert
                        this.$toastr.e('Validation Errors');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Contract');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            searchSellerAgents(search, loading){
                //Wrapper since we cannot pass in extra variables to the VueSelect handler
                this.searchAgents(search, loading, 'seller');
            },

            searchManagerAgents(search, loading){
                //Wrapper since we cannot pass in extra variables to the VueSelect handler
                this.searchAgents(search, loading, 'manager');
            },

            searchAgents(search, loading, agent_type){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'agents.last_name',
                    typeahead: true,
                    filters: {
                        'agents.is_active': 1,
                    },
                };

                //Show a Loading INdicator?
                this.$http.get('/agents', payload)
                        .then(response => {
                            loading(false);

                            // //Set the Data
                            // var agents = response.data.data;

                            // //Loop and Build
                            // for (var i = 0; i < response.data.data.length; i++)
                            // {
                            //     agents.push({id: response.data.data[i].id, agent_name: (response.data.data[i].first_name + ' ' + response.data.data[i].last_name)})
                            // }

                            // //Set the values
                            this[agent_type+'_agents'] = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        })
            },

            getSellerDetails(seller_type, seller_id){
                //Fire it
                this.$http.get('/contracts/seller/'+seller_type+'/'+seller_id)
                    .then(response => {
                        //Set it
                        this.products_sold = response.data.products_sold;
                        this.seller_details = response.data.seller_details;
                    });
            },

            setRequested(){
                //Set it
                this.contract.requested_date = moment(this.contract.created_at).format('YYYY-MM-DD');
            },
        },

        mounted() {
            //get the contract?
            this.getContract();
        }
    }
</script>